<!--
Author: TangChen
Date: 2018-09-27
Desc: 账户绑定组件
 -->
<template>
    <div class="comp-bind-acct comp">
        <div class="acct-con">
            <nav-bar :navs="navs" />
            <div v-show="!ocrShow" class="check-acct">
                <!-- 验证证件信息 -->
                <el-form
                    v-show="!checked"
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <div v-if="!hasTranAcct" class="cut-off-line top">
                        <span>选择银行</span>
                    </div>
                    <el-form-item v-if="!hasTranAcct" label="所属银行：" prop="bankType" class="bank">
                        <div class="bank-msg" :style="{'opacity':bankInfo.channelid?1:0}" v-on:click.prevent="showBank">
                            <div
                                v-if="bankInfo.channelid"
                                class="bank-img-sel clear"
                                :class="{'bg-w':bankInfo.channelid}"
                            >
                                <img
                                    :src="$util.getImg(bankInfo.bankid)"
                                    title="bank-img"
                                >
                                <span class="k-text-flow">{{ bankInfo.channelname.toString().substr(0, 6) }}</span>
                                <i class="paycenter">{{ bankInfo.paycentername.toString().substr(0, 4) }}</i>
                            </div>
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankType"
                            placeholder="请选择所属银行"
                            :maxlength="20"
                            suffix-icon="fa fa-money-check"
                        />
                    </el-form-item>
                    <el-form-item v-if="bankInfo.hkopenflag==='1'" label="开通汇款支付：" prop="hkopenflag" class="form-text">
                        <el-radio-group v-model="acctInfo.hkopenflag">
                            <el-radio :label="'1'">
                                是
                            </el-radio>
                            <el-radio v-if="!isRemit" :label="'0'">
                                否
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="!hasTranAcct" label="银行卡号码：" prop="bankNo">
                        <div class="bank-code el-message--warning" :class="{'show':showBankCard&&pwdForm.bankNo!==''}">
                            {{ $util.getNewCard(pwdForm.bankNo) }}
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankNo"
                            placeholder="请输入银行卡号码"
                            :maxlength="20"
                            v-on:focus="showBankCard=true"
                            v-on:blur="showBankCard=false"
                        />
                    </el-form-item>
                    <div v-if="!hasTranAcct" class="cut-off-line">
                        <span>请填写您在该银行开户时提供的身份信息(非身份证开户需先填写信息，再上传证件)</span>
                    </div>
                    <el-form-item v-if="!hasTranAcct" label="开户姓名：" prop="userName">
                        <el-input
                            v-model.trim="pwdForm.userName"
                            :placeholder="'请' + holderText + '真实姓名'"
                            :maxlength="20"
                            :disabled="dis || dateSet.dis"
                        />
                    </el-form-item>
                    <el-form-item label="开户证件：" prop="certType" class="cert-types-line">
                        <el-select
                            v-model="pwdForm.certType"
                            placeholder="请选择证件类型"
                            :style="{'width':btnStyle}"
                            :disabled="dis"
                            v-on:change="checkCertNoAgain"
                        >
                            <el-option
                                v-for="item in certTypes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-button v-show="ocrUpdBtnS" :disabled="ocrDis" type="primary" v-on:click="gotoOcr">
                            {{ ocrBtnText }}
                        </el-button>
                    </el-form-item>
                    <el-form-item label="证件号码：" prop="certNo">
                        <el-input
                            v-model.trim="pwdForm.certNo"
                            :placeholder="'请' + holderText + '证件号码'"
                            :maxlength="20"
                            :disabled="dis || dateSet.dis"
                            v-on:blur="initBirthdate"
                        />
                    </el-form-item>
                    <el-form-item v-if="!hasTranAcct" label="证件有效期：" prop="vailddate">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </el-form-item>
                    <el-form-item v-if="!hasTranAcct" label="出生日期：" prop="birthdate" class="birthdate-select">
                        <date-picker :date="dateSetBirth" v-on:date-get="dateInterval_birth" />
                    </el-form-item>
                    <el-form-item
                        v-if="!hasTranAcct"
                        label="银行预留手机号码："
                        prop="mobile"
                        :class="{'form-text':!(bankInfo && bankInfo.identifytype==='1')}"
                    >
                        <el-input
                            v-model.trim="pwdForm.mobile"
                            placeholder="请输入银行预留手机号码"
                            :maxlength="11"
                        />
                    </el-form-item>
                    <el-form-item v-if="isRemit" label="银行卡正反面：" class="form-text">
                        <bankcard-upload v-on:change="bankcardUp" />
                    </el-form-item>
                    <!--<el-form-item
                        v-if="bankInfo && bankInfo.identifytype==='1'"
                        label="手机验证码："
                        prop="verifyCode"
                    >
                        <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input>
                    </el-form-item>-->
                    <el-form-item style="margin-left:-80px">
                        <div class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                            <div style="display: flex; align-items: flex-start;">
                                <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                                <span v-if="isRemit" style="padding-left:5px;line-height:30px;width:518px;">
                                    本人承诺提供的身份信息、银行卡信息真实、合法、有效，并同意泰康人寿收集、使用本人“银行卡号、手机号、姓名、身份证号”于绑定银行卡和基金交易的用途。
                                </span>
                                <span v-else style="padding-left:5px;line-height:30px;width:518px;">
                                    本人已经仔细阅读并同意
                                    <span style="cursor: pointer;color:red;" v-on:click="isShowAgreement = true">《委托支付协议》</span>
                                    等法律文件，同意本人发卡行提供的快捷支付服务协议内容，
                                    并同意泰康人寿使用本人“银行卡号、手机号、姓名、身份证号”于绑定银行卡和基金交易的用途。
                                </span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" v-on:click="mobileCheck">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="backPage">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="openTran" label="" class="form-text">
                        <div class="step-info error">
                            <span>{{ openTran + '，无法进行绑定。' }}</span>
                            <span
                                v-if="openTran.indexOf('开户')>-1"
                                class="info-btn"
                                v-on:click.prevent="$router.push({name:'bindnewacct'})"
                            >立即开立交易账号</span>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 验证交易密码 -->
                <el-form
                    v-if="checkTPwd"
                    ref="acctInfo"
                    :model="acctInfo"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.name }}
                        </div>
                    </el-form-item>
                    <el-form-item label="证件号码：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.certNo }}
                        </div>
                    </el-form-item>
                    <el-form-item label="交易密码：" prop="pwd">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            :type="pwdType"
                            placeholder="请输入以上交易账号对应的交易密码"
                            :maxlength="16"
                        >
                            <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" v-on:click="submitInfo('acctInfo')">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="returnCheck()">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 开户信息 -->
                <div v-if="opentAcct">
                    <open-acct :data="openPar" v-on:get-acct="getAcct" />
                </div>
            </div>
            <el-row v-show="ocrShow" class="investor-data-up">
                <el-alert
                    title="注意：上传的图片大小每张不能超过5M，格式类型只支持bmp，jpg，jpeg，png，非身份证每张不能超过1.5M且请至少上传两张有效证件照。请仔细核对您的证件信息，如信息识别有误请您重新录入"
                    type="warning"
                    show-icon
                    :closable="false"
                />
                <ocr-upd v-if="!isIE9 && pwdForm.certType == '0' && ocrShow" :formdatas="pwdForm" v-on="{success:imgUp,back:regression}" />
                <ocr-upd-other
                    v-else-if="!isIE9 && pwdForm.certType != '0' && ocrShow"
                    :formdatas="pwdForm"
                    v-on="{success:imgUp,back:regression}"
                />
                <div v-else class="cant-up">
                    <div class="cant-info">
                        为保证上传证件质量，暂不支持IE9浏览器上传认证证件照，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。
                    </div>
                    <el-button class="medium" v-on:click="$router.back()">
                        确定
                    </el-button>
                </div>
            </el-row>
        </div>
        <bank-lists :bank-visible="bankVisible" url="acct/opentradeacct/banklist" v-on:bank-hide="getBankMsg" />
        <result v-if="bindResult" :result="result" v-on:login-now="findPwd" v-on:return-login="backPage" />
        <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
        <mobile-code :mobile-visible="mobileVisible" v-on:verify-in="mobileCode" />
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <agreement2 v-model="isShowAgreement" agrCon="agreement_payment" title="委托支付协议" v-on:all-read="isShowAgreement=false"></agreement2>
    </div>
</template>
<script>
import bankLists from "@/components/form/bankLists.vue";
import openAcct from "@/components/form/openAcct.vue";
import navBar from "@/components/layout/navBar.vue";
import result from "@/components/layout/result.vue";
import Agreement from "@/components/form/agreement.vue";
import ocrUpd from "@/components/form/ocrUpd.vue";
import ocrUpdOther from "@/components/form/ocrUpdOther.vue";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCode.vue";
import agreement2 from "@/components/form/agreement2.vue";
import bankcardUpload from "@/components/form/bankcardUpload.vue";

export default {
    name: "BindAcct",
    components: {
        navBar,
        bankLists,
        openAcct,
        mobileCode,
        result,
        Agreement,
        ocrUpd,
        ocrUpdOther,
        datePicker,
        imgCode,
        agreement2,
        bankcardUpload
    },
    props: {
        way: Boolean
    },
    data() {
        return {
            dialogVisible: false,
            mobileVisible: false,
            showBankCard: false, // 是否着重显示银行卡号码
            agrType: "add", // 协议类型，增卡协议
            time: 0, // 验证码再次发送间隔
            countrycode: [],//国家码
            machinecode: [],//座机地区码
            natural: [],//自然人标识
            profession: [],
            pwdForm: { // 表单参数配置
                userName: "",
                certType: "0",
                certNo: "",
                vailddate: "",
                bankType: "",
                bankNo: "",
                mobile: "",
                verifyCode: "",
                birthdate: "",
                address: "",
                income: "",//年收入
                companyname: "",//单位工作名称
                profession: ""//投资人职业
            },
            setInfoFlag: "1", //纯代销注册状态标示
            protocol: false,
            pwdType: "password",
            iconCla: "fa fa-eye-slash",
            acctInfo: { // 交易账户信息
                name: "",
                certNo: "",
                pwd: "",
                hkopenflag: ""
            },
            dis: false,
            result: {// 结果页面信息
                cla: "register-success",
                msg: "",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    ctd: "秒后自动跳转用户中心",
                    time: 10,
                    event: "return-login"
                }
            },
            bindResult: false, // 是否显示绑定结果页
            bankVisible: false, // 是否弹出银行卡列表
            checked: false, // 手机或银行卡校验是否通过
            navs: [{val: "验证证件信息", active: true}, {val: "验证交易密码"}, {val: "完成绑定", icon: "fa fa-check"}], // 导航栏配置
            certTypes: [], // 证件类型
            openTran: "", // 重新开立交易账户提示信息
            btnMsg: "获取短信验证码",
            hasTranAcct: false, // 是否有交易账号
            locked: false, // 是否已发送短信验证码
            bankInfo: {},
            checkTPwd: false, // 显示验证交易密码页面
            opentAcct: false,
            openPar: {},
            rules: { // 校验规则
                userName: [
                    {validator: this.checkName, trigger: "blur"}
                ],
                income: [
                    { required: true, message: "请输入年收入", trigger: "blur" }
                ],
                certType: [
                    {required: true, message: "请选择证件类型", trigger: "change"}
                ],
                certNo: [
                    {required: true, message: "请输入证件号码", trigger: "blur"},
                    {validator: this.checkCertNo, trigger: "blur"}
                ],
                vailddate: [
                    {required: true, message: "请选择证件有效期", trigger: "blur"}
                ],
                birthdate: [
                    {required: true, message: "请选择出生日期", trigger: "blur"}
                ],
                bankType: [
                    {required: true, message: "请选择所属银行", trigger: "blur"}
                ],
                pwd: [
                    {required: true, message: "请输入绑定账号的交易密码", trigger: "blur"}
                ],
                bankNo: [
                    {required: true, message: "请输入银行卡号码", trigger: "blur"},
                    {validator: this.$util.validateBankNum, trigger: "blur"}
                ],
                mobile: [
                    {required: true, message: "请输入银行预留手机号码", trigger: "blur"},
                    {validator: this.$util.validateMobile, trigger: "blur"}
                ],
                verifyCode: [
                    {validator: this.$util.validateVerifyCode, trigger: "blur"}
                ]
            },
            ocrBtnText: "上传证件照",
            ocrShow: false,
            isIE9: false,
            ocrUpdBtnS: false,
            hasOcr: "0",
            dateSet: {type: "3", max: "", dis: false, val: "", text: "请选择证件有效期"},
            dateSetBirth: {type: "3", max: "", dis: false, val: "", text: "请选择出生日期"},
            btnStyle: "50%",
            holderText: "输入",
            ocrupdflag: "0", //上传成功标示
            checkbox: false,// 是否同意隐私政策
            isShowAgreement: false,// 是否展示文件内容弹窗
            isRemit: false, // 是否汇款卡，需要上传银行卡照片
            imgBase64: {} //银行卡照片Base64
        };
    },
    computed: {
        ocrDis: function () {
            return ((this.pwdForm.certNo && (!this.hasTranAcct ? this.pwdForm.userName : true) && this.pwdForm.vailddate && this.pwdForm.birthdate) || this.pwdForm.certType == "0") ? false : true;
        }
    },
    watch: {
        hasTranAcct(val) {
            this.returnCheck();
        },
        "pwdForm.certType"(val) {
            if (this.setInfoFlag === "0") {
                this.setInfoFlag = "1";
                return false;
            }
            if (this.ocrUpdBtnS === true) {
                this.dateSet.dis = (val == "0" && this.hasOcr == "1") ? true : false;
                this.dateSetBirth.dis = (val == "0" && this.hasOcr == "1") ? true : false;
            }
            // this.pwdForm.userName = "";
            this.pwdForm.certNo = "";
            // this.pwdForm.vailddate = "";
            // this.pwdForm.birthdate = "";
            this.pwdForm.address = "";
            this.ocrupdflag = "0";
            // this.$set(this.dateSet, "val", "");
            // this.$set(this.dateSet, "time", new Date().getTime());
            // this.$set(this.dateSetBirth, "val", "");
            // this.$set(this.dateSetBirth, "time", new Date().getTime());
            // this.$refs.pwdForm.clearValidate();
        },
        "dateSet.dis"(val) {
            this.holderText = val == true ? "上传证件获取" : "输入";
            this.$set(this.dateSet, "text", val == true ? "请上传证件获取证件有效期" : "请选择证件有效期");
            this.$set(this.dateSetBirth, "text", val == true ? "请上传证件获取出生日期" : "请选择出生日期");
        }
    },
    created() {
        this.countrycode = this.$cache.getDict("150136");
        this.machinecode = this.$cache.getDict("150137");
        this.natural = this.$cache.getDict("120200");
        this.profession = this.$cache.getDict("150141");
        this.certTypes = this.$cache.getDict("130007").filter(val=> val.subitemname === "身份证");
        const conf = this.$util.getConfig().const;
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.dateSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateSetBirth.min = this.$util.fmtDate("19000101");
        this.hasOcr = this.$cache.getParams("hasocr");
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
        // this.certTypes = this.$cache.getDict("130007");
        const info = this.$cache.getUser();
        if (info.usertype === "2" && info.bindflag !== "1") {
            this.pwdForm.certType = info.certificatetype;
            this.pwdForm.certNo = info.certificateno;
            this.pwdForm.vailddate = info.vailddate;
            this.pwdForm.birthdate = info.birthdate;
            if (info.vailddate.trim()) this.$set(this.dateSet, "val", this.$util.fmtDate(info.vailddate));
            this.$set(this.dateSet, "time", new Date().getTime());
            if (info.birthdate.trim()) this.$set(this.dateSetBirth, "val", this.$util.fmtDate(info.birthdate));
            this.$set(this.dateSetBirth, "time", new Date().getTime());
            this.pwdForm.userName = info.custname;
            this.dis = true;
            this.setInfoFlag = "0";
        }
        this.bindWay(this.way);
        if (!this.hasTranAcct) {
            this.getOcrOpenStatus();
        }
    },
    methods: {
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.sendBank(val);
            }
        },
        /* 回退到鉴权界面 */
        returnCheck() {
            this.checked = false;
            this.locked = false;
            this.checkTPwd = false;
            this.opentAcct = false;
            this.openTran = "";
            this.bindWay(this.hasTranAcct);
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.pwdForm.validateField("certNo");
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            if (this.bankInfo.identifytype === "1" && !this.isRemit) {
                this.mobileVisible = true;
            } else {
                if (this.isRemit) {
                    this.showAcctPage();
                } else {
                    this.sendBank();
                }
            }
        },
        /* 校验用户姓名 */
        checkName(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                this.$util.validateName(rule, value, callback);
            }
        },
        // 获取用户信息
        getAcct(val) {
            if (!val) {
                return this.returnCheck();
            }
            const _this = this;
            // 获取用户性别
            let sexVal = "";
            if (_this.pwdForm.certType === "0") {
                sexVal = _this.getSex(_this.pwdForm.certNo);
            } else {
                sexVal = val.sex;
            }
            const conf = this.$util.getConfig().const;
            const _x = {
                vailddate: _this.pwdForm.vailddate,
                tradepwd: _this.$util.enc(val.pwd),
                delivertype: val.delivertype,
                deliverway: val.deliverway,
                cardtelno: _this.pwdForm.mobile,
                email: val.email,
                address: val.address,
                telnocycode: val.telnocycode,
                telnoareacode: val.telnoareacode,
                telno: val.telno,
                fax: val.fax,
                faxcycode: val.faxcycode,
                faxareacode: val.faxareacode,
                postcode: val.postcode,
                sex: sexVal,
                bankprovince: val.bankprovince,
                bankcity: val.city,
                bankname: val.bankname,
                hkopenflag: this.acctInfo.hkopenflag,
                assetssource: val.assetssource,
                country: val.country,
                otherprovince: val.otherprovince,
                province: val.otherprovince,
                isdigniaryorceo: val.isdigniaryorceo,
                belongregion: val.belongregion,
                location: val.location,
                livingcountry: val.cncountry,
                branchnum: val.branchcode,
                birthdate: _this.pwdForm.birthdate,
                beneficiary: val.beneficiary,
                beneficiarytype: val.beneficiarytype,
                beneficiaryno: val.beneficiaryno,
                beneficiarydate: val.beneficiarydate,
                beneficiarysex: val.beneficiarysex,
                beneficiarybirthday: val.beneficiarybirthday,
                occupation: val.occupation,
                vocationsupple: val.vocationsupple,
                //benefisself: val.benefisself,
                //beneficiaryaddr: val.beneficiaryaddr,
                livingaddressprovince: val.cnprovince,
                livingaddresscity: val.cncity,
                livingaddresscounty: val.cncounty,
                livingaddress: val.address,
                specialpersonflag: val.natural,
                educationlevel: val.educationlevel,
                addresscity: val.cncity,
                addresscounty: val.county,
                beneficiarycountry: val.beneficiarycountry, //受益人国家
                beneficiaryaddrprovince: val.beneficiaryaddrprovince,//  受益人省
                beneficiaryaddrcity: val.beneficiaryaddrcity, //受益人城市
                beneficiaryaddrcounty: val.beneficiaryaddrcounty, //受益人县
                beneficiaryemail: val.beneficiaryemail, //受益人邮箱
                beneficiarypostcode: val.beneficiarypostcode, //受益人邮编
                benefisself: val.benefisself, //受益人是否是本人
                beneficiaryvocation: val.beneficiaryvocation, //受益人职业
                beneficiarytelnocycode: val.beneficiarytelnocycode, //国家码
                beneficiarytelnoareacode: val.beneficiarytelnoareacode, //国家码
                beneficiarytelno: val.beneficiarytelno, //手机号
                beneficiaryaddr: val.beneficiaryaddr, //受益人详细地址
                benefrelation: val.benefrelation,
                actualctrladdr: val.actualctrladdr,//控制人
                actualctrladdrcity: val.actualctrladdrcity,
                actualctrladdrcounty: val.actualctrladdrcounty,
                actualctrladdrprovince: val.actualctrladdrprovince,
                actualctrlbirthday: val.actualctrlbirthday,
                actualctrlcountry: val.actualctrlcountry,
                actualctrlemail: val.actualctrlemail,
                actualctrlidcode: val.actualctrlidcode,
                actualctrlidtype: val.actualctrlidtype,
                actualctrlname: val.actualctrlname,
                actualctrlpostcode: val.actualctrlpostcode,
                actualctrlsex: val.actualctrlsex,
                actualctrltelno: val.actualctrltelno,
                actualctrltelnocycode: val.actualctrltelnocycode,
                actualctrltelnoareacode: val.actualctrltelnoareacode,
                actualctrlvalidate: val.actualctrlvalidate,
                actualctrlvocation: val.actualctrlvocation,
                actualisself: val.actualisself,
                actualrelation: val.actualrelation,
                hkpaycenterflag: "0",
                certificatetype: _this.pwdForm.certType
            };
            if (_this.isRemit) {
                _x.hkopenflag = "1";
                _x.hkpaycenterflag = "1";
                _x.bankid = _this.bankInfo.bankid;
                _x.channelid = _this.pwdForm.bankType;
                _x.depositacct = _this.pwdForm.bankNo;
                _x.depositprov = val.bankprovince;
                _x.depositcity = val.city;
                _x.paycenterid = _this.bankInfo.paycenterid;
                _x.channelname = _this.bankInfo.channelname;
                _x.moneyaccount = "";
                _x.exchangebankcode = val.branchcode;
                _x.exchangecode = val.branchcode;
                _x.certificatetype = _this.pwdForm.certType;
                _x.certificateno = _this.pwdForm.certNo;
                _x.custname = _this.pwdForm.userName;
            }
            _this.$util.request("acct/common/riskycust", {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                invtp: "1"
            }, "GET").then(res => {
                if (res.data) {
                    if (res.data[0].flag === "1") {
                        _this.$message.warning("账号为风险客户，请联系客服进行开户操作!");
                        return false;
                    } else {
                        _this.$util.request("acct/opentradeacct/individual", _x, "POST").then(res => {
                            let _param = {
                                "isdigniaryorceo": val.specialpersonflag,
                                "assetssource": val.assetssource
                            };
                            _this.$util.adddigniaryorceo(_param);
                            _this.navs = [{val: "身份验证", active: true}, {val: "补充资料", active: true}, {
                                val: "完成绑定",
                                icon: "fa fa-check",
                                active: true
                            }];
                            _this.opentAcct = false;
                            _this.bindResult = true;
                            if (res.data) {
                                _this.$cache.refreshUser();
                                _this.result.msg = "您已成功绑定证件号为" + _this.pwdForm.certNo + "的交易账户";
                                if (_this.isRemit) {
                                    _this.uploadBankCard();
                                }
                            } else {
                                _this.result.cla = "register-fail";
                                _this.result.msg = res.msg;
                            }
                        });
                    }
                } else {
                    _this.result.cla = "register-fail";
                    _this.result.msg = res.msg;
                }
            });
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        // 账户绑定选项处理
        bindWay(val) {
            this.hasTranAcct = val;
            if (!val) {
                this.navs = [{val: "身份验证", active: true}, {val: "补充资料"}, {val: "完成绑定", icon: "fa fa-check"}];
            } else {
                this.navs = [{val: "验证身份信息", active: true}, {val: "验证交易密码"}, {val: "完成绑定", icon: "fa fa-check"}];
            }
        },
        // 根据身份证号判断性别
        getSex(psidno) {
            let sexno = "";
            if (psidno.length === 18) {
                sexno = psidno.substring(16, 17);
            } else if (psidno.length === 15) {
                sexno = psidno.substring(14, 15);
            } else {
                return false;
            }
            const tempid = sexno % 2;
            return tempid === 0 ? "0" : "1";
        },
        /* 回到首页 */
        findPwd() {
            this.$router.push("/home");
        },
        /* 显示用户信息补充页面 */
        showAcctPage() {
            this.checked = true;
            this.opentAcct = true;
            this.openPar = {
                certType: this.pwdForm.certType,
                address: this.pwdForm.address,
                bankid: this.bankInfo.bankid,
                isBranch: this.bankInfo.isneedbank
            };
            this.navs = [{val: "身份验证", active: true}, {val: "补充资料", active: true}, {
                val: "完成绑定",
                icon: "fa fa-check"
            }];
        },
        mobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 提交表单数据,校验手机验证码 */
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                // if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                //     this.$message.warning("请先上传有效证件照");
                //     return false;
                // }
                if (valid) {
                    if (!this.hasTranAcct) {
                        if (this.bankInfo.identifytype === "1" && !this.isRemit) {
                            if (!this.locked) {
                                this.$message({
                                    type: "warning",
                                    message: "请先发送手机短信验证码"
                                });
                                return false;
                            }
                        }
                        this.protocol = true;
                    } else {
                        // 查询账户绑定情况
                        this.$util.request("acct/bindtradeacct/status", {
                            certificatetype: this.pwdForm.certType,
                            certificateno: this.pwdForm.certNo,
                            custname: this.pwdForm.userName
                        }).then(res => {
                            if (res.data) {
                                // 账户状态0-已绑定 1-未开户 2-已开户
                                const _x = res.data[0].status;
                                if (_x === "2") {
                                    this.acctInfo = {
                                        name: res.data[0].custname,
                                        certNo: this.pwdForm.certNo
                                    };
                                    this.checkTPwd = true;
                                    this.checked = true;
                                    this.navs = [{val: "验证证件信息", active: true}, {
                                        val: "验证交易密码",
                                        active: true
                                    }, {val: "完成绑定", icon: "fa fa-check"}];
                                } else {
                                    this.openTran = _x === "0" ? "该交易账号已绑定其他账户" : "您提供的证件尚未在我司开户";
                                }
                            }
                        });
                    }
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    const encNum = _this.$util.enc(_this.acctInfo.pwd);
                    if (_this.hasTranAcct) {
                        _this.$util.request("acct/bindtradeacct/bind", {tradepwd: encNum}, "POST").then(res => {
                            _this.navs = [{val: "验证证件信息", active: true}, {
                                val: "验证交易密码",
                                active: true
                            }, {val: "完成绑定", icon: "fa fa-check", active: true}];
                            _this.checkTPwd = false;
                            _this.bindResult = true;
                            if (res.data) {
                                //_this.$cache.refreshUser();
                                _this.result.msg = "您已成功绑定证件号为" + _this.acctInfo.certNo + "的交易账户";
                                /* 更新出生日期和有效期 */
                                _this.$util.request("acct/cust/profile", {
                                    "isOcrType": "1",
                                    "certificateno": _this.pwdForm.certNo,
                                    "certificatetype": _this.pwdForm.certType,
                                    "vailddate": _this.pwdForm.vailddate,
                                    "birthdate": _this.pwdForm.birthdate,
                                    tradepwd: encNum
                                }, "PUT").then(res => {
                                    if (res.data) {
                                        _this.$cache.refreshUser();
                                    }
                                });
                            } else {
                                _this.result.cla = "register-fail";
                                _this.result.msg = res.msg;
                            }
                        });
                        return false;
                    }
                } else {
                    return false;
                }
            });
        },
        /* 校验手机验证码 */
        checkVerifyCode(val) {
            this.$util.request("acct/opentradeacct/authcheckmsg", {verifycode: val}, "POST").then(res => {
                if (res.data) {
                    this.showAcctPage();
                }
            });
        },
        /* 显示银行卡列表弹框 */
        showBank() {
            this.bankVisible = !this.bankVisible;
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.checkbox = false;
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
                this.bankInfo.hkopenflag = val.bank.hkopenflag;
                this.acctInfo.hkopenflag = this.bankInfo.hkopenflag;
                this.isRemit = this.bankInfo.paycenterid == "2000";
            }
            if (this.isRemit) {
                this.acctInfo.hkopenflag = "1";
            }
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
            }
        },
        /* 提交表单数据 */
        mobileCheck() {
            if(!this.checkbox){
                const text = this.isRemit ? "根据相关法规要求，请仔细阅读本页提示内容，并勾选“承诺并同意”选项。" : "根据相关法规要求，请仔细阅读相关文件，并勾选“我已阅读并同意”选项。";
                return this.$alert(text, "提示", {confirmButtonText: "确定"});
            }
            if (this.isRemit) {
                if (!this.imgBase64.frontBank && !this.imgBase64.backBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡正反面文件"
                    });
                    return;
                }
                if (!this.imgBase64.frontBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡正面文件"
                    });
                    return;
                }
                if (!this.imgBase64.backBank) {
                    this.$message({
                        type: "warning",
                        message: "请上传银行卡反面文件"
                    });
                    return;
                }
                this.submitForm("pwdForm");
                return;
            }
            if (this.hasTranAcct) {
                this.submitForm("pwdForm");
                return;
            }
            if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                this.$message.warning("请先上传有效证件照");
                return false;
            }
            const _this = this;
            let mes = "";
            // 处理银行卡找回密码表单数据校验
            if (
                _this.checkBank ||
                    (!_this.hasTranAcct && _this.hasTranAcct !== undefined)
            ) {
                for (const key in _this.pwdForm) {
                    if (key !== "verifyCode" && key !== "type") {
                        _this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            }
            if (mes !== "") {
                return false;
            }
            this.dialogVisible = true;
        },
        /* 银行卡鉴权发送鉴权信息 */
        sendBank(val) {
            let _this = this;
            let data = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName,
                mobile: this.pwdForm.mobile,
                bankcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                verifycode: val
            };
            this.$util.request("acct/opentradeacct/authsend", data, "POST").then(res => {
                if (res.data) {
                    /* 倒计时 */
                    if (this.bankInfo.identifytype === "1") {
                        let result = res.data[0];
                        if (result.comtype && result.comtype === "socket") {
                            this.showAcctPage();
                        } else {
                            _this.time = res.data[0].sendperiod;
                            _this.locked = true;
                            _this.$util.btnDisabled(this);
                            _this.submitForm("pwdForm");
                        }
                    } else if (this.bankInfo.identifytype === "2") {
                        this.showAcctPage();
                    } else if (this.bankInfo.identifytype === "3") {
                        const pageUrl = res.data[0].url;
                        this.$util.newWinOpen(pageUrl);
                        this.$util.confirmBankAuth(this, {}, "acct/opentradeacct/authresult", function () {
                            _this.showAcctPage();
                        });
                    }
                }
            });
        },
        gotoOcr() {
            let _this = this;
            let checkArtOcrForm = true;
            if (this.hasOcr !== "1") {
                for (const key in _this.pwdForm) {
                    if (key == "userName" || key == "certType" || key == "certNo" || key == "vailddate" || key == "birthdate") {
                        _this.$refs["pwdForm"].validateField(key, function(str) {
                            if (str) {
                                checkArtOcrForm = false;
                            }
                        });
                    }
                }
            }
            // ocr走人工审核需要姓名，证件号码、证件有效期、出生日期
            if (this.hasOcr !== "1" && !checkArtOcrForm) {
                return;
            }else {
                if (this.ocrupdflag === "1") {
                    const _this = this;
                    this.$confirm("已成功上传身份证件，是否重新上传？", "重新上传", {
                        confirmButtonText: "重新上传",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        _this.ocrShow = true;
                        _this.navs = [{val: "身份验证（上传证件照）", active: true}, {val: "补充资料"}, {
                            val: "完成绑定",
                            icon: "fa fa-check"
                        }];
                    });
                } else {
                    this.ocrShow = true;
                    this.navs = [{val: "身份验证（上传证件照）", active: true}, {val: "补充资料"}, {val: "完成绑定", icon: "fa fa-check"}];
                }
            }
        },
        imgUp(flag) {
            this.ocrupdflag = "1";
            this.dateSet.dis = true;
            this.dateSetBirth.dis = true;
            if (flag) {
                this.pwdForm.certNo = flag.certificateno;
                this.pwdForm.userName = flag.custname;
                this.pwdForm.vailddate = flag.vailddate;
                this.pwdForm.birthdate = flag.birthdate;
                this.pwdForm.address = flag.address;
            }
            this.dateSet.val = this.$util.fmtDate(this.pwdForm.vailddate);
            this.dateSetBirth.val = this.$util.fmtDate(this.pwdForm.birthdate);
            this.$message({
                type: "success",
                message: "上传证件成功！"
            });
            this.ocrShow = false;
            this.$set(this.navs[0], "val", "身份验证");
        },
        regression() {
            this.ocrShow = false;
            this.$set(this.navs[0], "val", "身份验证");
            //this.navs = [{ val: "身份验证", active: true }, { val: "补充资料" }, { val: "完成绑定", icon: "fa fa-check" }];
        },
        /* 返回上一页页 */
        backPage() {
            this.$router.push({name: "info"});
        },
        dateInterval(val) {
            this.pwdForm.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.pwdForm.validateField("vailddate");
        },
        dateInterval_birth(val) {
            this.pwdForm.birthdate = val !== null ? val.replace(/-/g, "") : "";
        },
        getOcrOpenStatus() {
            const _this = this;
            const _x = this.$util.src("/acct/ocr/check", {}, true);
            const _data = {};
            this.$req({
                method: "GET",
                url: _x,
                timeout: 20000,
                data: _data
            }).then(res => {
                if (res.code === "0000000") {
                    if (res.record[0][0].isOpenOcr == "1") {
                        _this.ocrUpdBtnS = true;
                        _this.btnStyle = "38%";
                        // ump开关(走ocr还是人工审核)
                        if (_this.pwdForm.certType === "0" && _this.hasOcr == "1") {
                            _this.dateSet.dis = true;
                            _this.dateSetBirth.dis = true;
                        } else {
                            _this.dateSet.dis = false;
                            _this.dateSetBirth.dis = false;
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(() => {
            });
        },
        initBirthdate() {
            //身份证
            if (this.pwdForm.certType === "0") {
                const sIdNo = this.pwdForm.certNo;
                const that = this;
                that.$util.validateCertNo("",sIdNo,function(){
                    if (sIdNo.length === 15) {
                        that.pwdForm.birthdate = "19" + sIdNo.substr(6, 6);
                    } else if (sIdNo.length === 18) {
                        that.pwdForm.birthdate = sIdNo.substr(6, 8);
                    }
                    that.$set(that.dateSetBirth, "val", that.$util.fmtDate(that.pwdForm.birthdate, "-"));
                },"0");
            }
        },
        bankcardUp (val) {
            this.imgBase64 = val;
        },
        uploadBankCard () {
            const _this = this;
            _this.$req({
                method: "POST",
                url: "/acct/bankcheck/upload/base64",
                timeout: 60000,
                data: _this.imgBase64,
                headers: { "Content-Type": "multipart/form-data" }})
                .then(res => {
                    if (res.code != "0000000") {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(() => { });
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";

    .comp-bind-acct {
        .acct-con {
            padding: 20px;
            .cert-types-line {
                > .el-form-item__content {
                    > .el-select {
                        width: 38%;
                        padding-right: 2%;
                    }
                    > .el-button {
                        width: 10%;
                        padding: 12px 0px;
                    }
                }
            }
            .investor-data-up {
                margin-top: 20px;
            }
            .cant-info {
                text-align: center;
                font-size: 18px;
                color: #333333;
                line-height: 30px;
                margin: 20px auto;
            }
            .cant-up {
                margin: 30px auto;
                width: 100%;
                text-align: center;
            }
            .birthdate-select .el-checkbox.date-check {
                display: none;
            }
        }
    }
</style>
